import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericModal } from 'src/app/interface/data.interface';

@Component({
  selector: 'app-success-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {
  title: string = 'modal.changesSaved'
  labelButtonSave: string = 'modal.accept'
  subtitle: string = '';

  constructor(
    private matDialogRef: MatDialogRef<ErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) private payload?: GenericModal) {
    if (this.payload && this.payload.title) {
      this.title = this.payload.title;
    }
    this.labelButtonSave = this.payload?.labelButtonSave || 'modal.accept';

    if (this.payload?.subtitle) {
      this.subtitle = this.payload.subtitle;
    }
  }

  ngOnInit(): void {

  }

  onEventAccept(event: boolean) {
    this.matDialogRef.close(event);
  }
}
